export default "__VITE_ASSET__DCLILhhA__"